// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3O-vb","contained":"Button_contained__tXK5D","text":"Button_text__u2NB2"};